// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"jZ-z","subtitle":"kZ-z","wrapper":"lZ-z","leftArrow":"mZ-z","rightArrow":"nZ-z"};